<div class="{uiClasses}spinner">
  <div class="circle"></div>
  {#if text}<span class="text">{text}</span>{/if}
  <slot></slot>
</div>
